// external
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import { ICard } from '@/interfaces/Card';
import { VuexAction } from '@/@types/index.d';

// store
import {
	NEXT_CARD,
	PREV_CARD,
	GET_THEME,
	GET_CARDS,
	GET_ACTIVE_CARD_INDEX,
	GET_CARD_CLICK_REPORT,
	SEND_REPORT,
} from '@/store/types';

// components
import { IReport } from '@/interfaces/IReport';
import Card from '../card/Card.vue';

@Component({
	components: {
		Card,
	},
})
export default class SmallCard extends Vue {
	@Getter(GET_THEME) getTheme!: string;

	@Getter(GET_CARDS) getCards!: ICard[];

	@Getter(GET_ACTIVE_CARD_INDEX) getActiveCardIndex!: number;

	@Getter(GET_CARD_CLICK_REPORT) getCardClickedReport!: IReport;

	@Action(NEXT_CARD) nextCard!: VuexAction<void>;

	@Action(PREV_CARD) prevCard!: VuexAction<void>;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	public exitIndex: number = -1;

	public exitLeft: boolean = true;

	removeExitClass() {
		const exitItem = document.getElementsByClassName(
			'mxr-carousel-item-exit'
		);
		if (exitItem && exitItem.length) {
			for (let i = 0; i < exitItem.length; i += 1) {
				exitItem[i].classList.remove('mxr-carousel-item-exit');
			}
		}
	}

	toggleExit(exitLeft: boolean) {
		this.exitLeft = exitLeft;
		// When changing the exitLeft property it causes Vue to check the other class arguments as well which
		// puts the `pc-project-item-exit` class back on the exiting meal so we need to pull it off.

		setTimeout(this.removeExitClass, 50);
	}

	rotateCard() {
		this.exitIndex = this.getActiveCardIndex;

		if (this.exitLeft) {
			this.nextCard();
		} else {
			this.prevCard();
		}

		this.sendReport(this.getCardClickedReport);
		// Remove the mealcard-exit class to make 2 item mixups look good.
		setTimeout(this.removeExitClass, 500);
	}

	public nextCardEvent() {
		this.toggleExit(true);
		// Give the toggleExit function enough time to remove the exit class
		setTimeout(this.rotateCard, 90);
	}

	prevCardEvent() {
		this.toggleExit(false);
		// Give the toggleExit function enough time to remove the exit class
		setTimeout(this.rotateCard, 90);
	}
}
